/**
 * 返回官网
 */
export function backOffical() {
  if (location.host.startsWith("dev")) {
    window.location.href = `https://devwww.12times.com`;
  } else if (location.host.startsWith("qas")) {
    window.location.href = `https://qaswww.12times.com`;
  } else {
    window.location.href = `https://www.12times.com`;
  }
}

/** 获取埋点环境 */
export const getBurialPointEnv = () => {
  const host = window.location.host;
  const prodHost = [
    "www.damselfish.cn",
    "platform.damselfish.cn",
    "damselfish.cn",
    "www.12times.com",
    "platform.12times.com",
    "12times.com",
  ];
  if (prodHost.includes(host)) {
    return "prod";
  } else {
    return "daily";
  }
};
